var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.title}},[_c('span',[_c('i',{staticClass:"bed-info-icon fas fa-bed"}),_vm._v(" 1/"+_vm._s(_vm.count)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }